import { Invoice } from '../../services/invoice.model';
import {
  PaymentProgressChangeAction,
  PaymentProgressStatus
} from '../../../components/payment-progress/payment-progress.action';
import ActionDispatcherService from '../../../common/actions/core/action-dispatcher.service';
import UserService from '../../../common/services/user/user.service';
import { UserResponse } from '../../../common/services/user/user.model';
import {
  PackageThumbnail,
  ListeningPackageType,
  PromocodeResponse,
  UserListeningPackagesResponse
} from '../../../common/services/package/package.model';
import { OpenCardAddContractAction } from '../../card-add-contract-dialog/card-add-contract-dialog.action';
import { BillInfoEditDialogAction } from '../edit/bill-info-edit-dialog.action';
import PackageService from '../../../common/services/package/package.service';
import { OtpService } from '../../services/otp.service';
import GlobalSpinnerService from '../../../common/services/spinner/global-spinner.service';
import NoAuthService from '../../../no-auth/services/noauth.service';
import { OtpAction } from '../../../no-auth/components/otp-dialog/otp-dialog.action';

/* @ngInject */
export default class BillInfoController {
  private invoice: Invoice;
  private packages: UserListeningPackagesResponse;
  private user: UserResponse;

  public maskedIdentityNo: string;
  private packet: PackageThumbnail;
  private promocode: string;
  private discount: PromocodeResponse;
  private msisdnError: boolean = false;
  public msisdnValid: boolean = false;
  public msisdnInput: string = '';

  constructor(
    private $state,
    private actionDispatcher: ActionDispatcherService,
    private userService: UserService,
    private packageService: PackageService,
    private globalSpinner: GlobalSpinnerService,
    private otpService: OtpService,
    private noAuthService: NoAuthService
  ) {
    this.actionDispatcher.dispatch(
      new PaymentProgressChangeAction(PaymentProgressStatus.INVOICE)
    );
    this.userService
      .getUserInfo()
      .then(user => {
        this.user = user;
        this.invoice.msisdn = user.msisdn;
        this.checkMsisdnValidity();
      });
    this.packageService
      .getUserListeningPackages()
      .then(result => (this.packages = result));

    this.noAuthService.validateOTP = (msisdn: string, smsCode: string) => {
      return this.otpService.validateOTP(msisdn, smsCode);
    };
  }

  public $onInit() {
    if (angular.isUndefined(this.invoice)) {
      return;
    }
    if (angular.isUndefined(this.packet)) {
      return;
    }

    if (typeof this.invoice.identityNo === 'string') {
      this.maskedIdentityNo = this.invoice.identityNo.replace(
        /(\d{3})(\d{5})(\d{3})/,
        '$1*****$3'
      );
    }
  }

  private checkMsisdnValidity() {
    if (this.user && this.user.msisdn) {
      const msisdn = String(this.user.msisdn);
      if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
        this.msisdnValid = true;
      } else {
        this.msisdnValid = false;
      }
    }
  }

  private showMsisdnError() {
    const msisdnField = document.getElementById("msisdnFieldBillInfo");
    if (msisdnField) {
      msisdnField.classList.add("form-field--error");
    }
    this.msisdnError = true;
  }

  private hideMsisdnError() {
    const msisdnField = document.getElementById("msisdnFieldBillInfo");
    if (msisdnField) {
      msisdnField.classList.remove("form-field--error");
    }
    this.msisdnError = false;
  }

  public sendOTP() {
    if (this.checkMsisdnField()) {
      this.globalSpinner.startIfNotActivated();
      const tmpMsisdn = this.getMsisdn();
      this.otpService.sendOTP(tmpMsisdn).then(result => {
        if (result) {
          this.actionDispatcher.dispatch(new OtpAction(tmpMsisdn, () => this.afterValidationMsisdn(tmpMsisdn)));
        }
        this.globalSpinner.stop();
      }).catch(() => {
        this.globalSpinner.stop();
      });
    }
  }

  private checkMsisdnField(): boolean {
    const msisdn = this.getMsisdn();
    if (msisdn.charAt(0) === "5" && msisdn.length === 10) {
      this.hideMsisdnError();
      return true;
    }
    this.showMsisdnError();
    return false;
  }

  private getMsisdn(): string {
    return String(this.msisdnInput || this.user.msisdn);
  }

  private afterValidationMsisdn(msisdn: string) {
    this.globalSpinner.startIfNotActivated();
    this.user.msisdn = msisdn;
    this.msisdnValid = true;
    this.globalSpinner.stop();
  }

  public overlayClick() {
    this.showMsisdnError();
    const msisdnInput = document.getElementById("msisdnBillInfo") as HTMLInputElement;
    if (msisdnInput) {
      msisdnInput.focus();
    }
    window.scrollTo(0, 0);
  }

  public isMsisdnValid(): boolean {
    return this.msisdnValid;
  }

  public isPaycellPackage() {
    return this.packet.type === ListeningPackageType.CREDITCARD;
  }
  public onEdit() {
    // this.$state.go('billInfoEdit');
    this.actionDispatcher.dispatch(new BillInfoEditDialogAction(this.invoice));
  }

  public onPaymentStep() {
    this.$state.go('payByCard');
  }

  public onNext() {}
}



// WEBPACK FOOTER //
// ./src/app/buy/bill-info/info/bill-info.controller.ts